import type { PdfEngine } from "@pdfking/pdfengine"
import { PathContentType } from "@pdfking/pdfengine"
import { RecordCreate, WaitPromises } from "@pdfking/tfunc"

import type { DroppedFiles } from "#public"

import { CreateFileName } from "./CreateFileName"

// A web host's one and only File → VirtualFile path, shared by every way a
// browser hands it real files: the window drop (see compatibility/browser's
// NativeDrop) and any file picker. Both end up dispatching the same
// {FileName: VirtualFile} record, so a view can't tell them apart.
//
// Bytes are ingested into the engine's persistent cache rather than mirrored
// through a throwaway blob URL, so a file survives a reload — a desktop host
// hands back `asset:`-mirrored remote files instead and lets the engine
// download them lazily. Either way a view only ever sees VirtualFiles.
// The browser's own `file.type` is a free-form MIME string (and empty for
// anything it can't guess), so the extension decides — `PathContentType` is
// the same mapping the engine uses everywhere else.

export const IngestFiles = (engine: PdfEngine, files: File[]): Promise<DroppedFiles> =>
  WaitPromises(
    RecordCreate(
      files.map(file => CreateFileName(file.name)),
      files.map(file => {
        const type = PathContentType([file.name])
        return engine.GenerateFile(file, { type })
      })
    )
  )
